import React from 'react';
import './FAQSection.css';

const faqs = [
  {
    q: 'Is it really free?',
    a: 'Yes — Sweet Justice serves complimentary frozen treats until supplies run out.'
  },
  {
    q: 'How much parking space is needed?',
    a: 'Please reserve 20–25 feet of flat space with room for a line so guests can queue safely.'
  },
  {
    q: 'Where do you serve?',
    a: 'We serve West Palm Beach and nearby communities. If you’re not sure, email us and we’ll see if we can make it work.'
  },
  {
    q: 'What’s on the menu?',
    a: 'Our menu rotates based on availability and always includes at least one sorbet/dairy‑free option.'
  },
  {
    q: 'What do you bring?',
    a: 'We’re a self-contained truck and bring cups, spoons, and napkins. We do not serve beverages.'
  },
  {
    q: 'Is there a guest minimum?',
    a: 'We recommend a minimum of 50 guests within 15 miles of zip code 33409. Contact us if your event is outside this range.'
  },
  {
    q: 'How long do you stay?',
    a: 'We serve until the freezer runs out — then we’re done!'
  },
  {
    q: 'What if there’s bad weather?',
    a: 'We operate rain or shine when safe. If weather is hazardous, we’ll work with you to reschedule.'
  },
  {
    q: 'How do I book?',
    a: 'Start by completing the digital waiver, propose a date, and our team will confirm details.'
  }
];

export default function FAQSection() {
  return (
    <section className="section faq-section" id="faq">
      <div className="container">
        <h2 className="section-title">Frequently Asked Questions</h2>
        <div className="faq-list" role="list">
          {faqs.map((item, idx) => (
            <details key={idx} className="faq-item" role="listitem">
              <summary className="faq-summary">
                <span>{item.q}</span>
                <svg className="chevron" width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
                  <path fill="currentColor" d="M7.41 8.58L12 13.17l4.59-4.59L18 10l-6 6-6-6z"/>
                </svg>
              </summary>
              <div className="faq-answer">
                <p>{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
